import React, { ReactNodeArray, useEffect, useMemo, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';

import {
  PageCardWrapper,
  PageCardThumbnail,
  PageCardInfoWrapper,
  PageCardTitleBox,
  PageCardTitleText,
  PageMoreButton,
  MoreIcon,
  PageCardURL,
  PaginationWrapeer,
  PaginationCustom,
  PageCardHover,
  PagecardHoverButton,
  IconHeatmap,
  IconUserflow,
  IconDelete,
  HeaderRightWrapper,
  PageViewSortWrapper,
  PageViewSortTitle,
  PageViewSortIcon,
  IconSMArrowDown,
  IconSearch,
  SpinnerWrapper,
  DataError,
  PageThumbnailImageSplit,
} from './styled';

import { RootState } from '../../../modules';
import {
  getPageListAsync,
  GET_PAGE_LIST,
} from '../../../modules/PageAnalytics/PageList';
import {
  GetPageListParamType,
  PageListPayload,
} from '../../../api/pageAnalytics/pageList/type';
import Spinner from '../../../components/UIComponents/Spinner';
import {
  ContentsLayout,
  ContainerGrid,
  ItemGrid,
} from '../../../components/UIComponents/Layout/DefaultLayout';
import Header from '../../../components/Organisms/Header';

const PageList = () => {
  // redux
  const loading = useSelector((state: RootState) => state.loading);
  const { pageListData } = useSelector((state: RootState) => state.pageList);
  const dispatch = useDispatch();

  const onGetPageList = (info: GetPageListParamType) => {
    dispatch(getPageListAsync.request(info));
  };
  // state
  // const [isMouseOver, setIsMouseOver] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [lastPageNumber, setLastPageNumber] = useState(1);
  const [isDescending, setIsDescending] = useState(true);
  const [descListData, setDescListData] = useState<PageListPayload[]>([]);
  const [ascListData, setAscListData] = useState<PageListPayload[]>([]);

  useEffect(() => {
    onGetPageList({});
  }, []);

  useEffect(() => {
    setLastPageNumber(Math.ceil(pageListData.length / 9));
    setDescListData(pageListData);
    const reverse = _.cloneDeep(pageListData);
    setAscListData(reverse.reverse());
  }, [pageListData]);

  const printPageList = useMemo(() => {
    const result: ReactNodeArray = [];
    if (descListData.length === 0 || ascListData.length === 0) {
      return (
        <DataError key="dataError">
          이벤트가 발생한 페이지가 없습니다.
        </DataError>
      );
    }

    if (isDescending) {
      for (
        let index = (pageNumber - 1) * 9;
        index <= pageNumber * 9 - 1;
        index += 1
      ) {
        if (index > descListData.length - 1) {
          break;
        }

        const element = descListData[index];

        result.push(
          <ItemGrid $desktop={4} key={element.simple_url}>
            <PageCardWrapper>
              <PageCardThumbnail>
                <img
                  src={`https://voda-media.nerdfactory.ai/${localStorage.getItem(
                    'voda_tenant'
                  )}/auto/${element.page_id}/${encodeURIComponent(
                    'page_screenshot'
                  )}`}
                  alt="..."
                />
                <PageCardHover>
                  <PagecardHoverButton
                    to={`/pageAnalytics/userFlowAnalysisList/userFlowAnalysis?pageid=${element.page_id}&pagelocation=${element.simple_url}&pagename=${element.page_name}`}
                  >
                    <IconUserflow />
                    <div>사용 흐름 분석</div>
                  </PagecardHoverButton>
                </PageCardHover>
              </PageCardThumbnail>
              <PageThumbnailImageSplit>
                <div />
              </PageThumbnailImageSplit>
              <PageCardInfoWrapper>
                <PageCardTitleBox>
                  <PageCardTitleText>{element.page_name}</PageCardTitleText>
                  {/* <PageMoreButton>
                    <MoreIcon />
                  </PageMoreButton> */}
                </PageCardTitleBox>
                <PageCardURL>{element.simple_url}</PageCardURL>
              </PageCardInfoWrapper>
            </PageCardWrapper>
          </ItemGrid>
        );
      }
    } else {
      for (
        let index = (pageNumber - 1) * 9;
        index <= pageNumber * 9 - 1;
        index += 1
      ) {
        if (index > ascListData.length - 1) {
          break;
        }

        const element = ascListData[index];

        result.push(
          <ItemGrid $desktop={4} key={element.simple_url}>
            <PageCardWrapper>
              <PageCardThumbnail>
                <img
                  src={`https://voda-media.nerdfactory.ai/${localStorage.getItem(
                    'voda_tenant'
                  )}/auto/${element.page_id}/${encodeURIComponent(
                    'page_screenshot'
                  )}`}
                  alt="..."
                />
                <PageCardHover>
                  <PagecardHoverButton
                    to={`/pageAnalytics/userFlowAnalysisList/userFlowAnalysis?pageid=${element.page_id}&pagelocation=${element.simple_url}&pagename=${element.page_name}`}
                  >
                    <IconUserflow />
                    <div>사용 흐름 분석</div>
                  </PagecardHoverButton>
                </PageCardHover>
              </PageCardThumbnail>
              <PageThumbnailImageSplit>
                <div />
              </PageThumbnailImageSplit>
              <PageCardInfoWrapper>
                <PageCardTitleBox>
                  <PageCardTitleText>{element.page_name}</PageCardTitleText>
                  {/* <PageMoreButton>
                    <MoreIcon />
                  </PageMoreButton> */}
                </PageCardTitleBox>
                <PageCardURL>{element.simple_url}</PageCardURL>
              </PageCardInfoWrapper>
            </PageCardWrapper>
          </ItemGrid>
        );
      }
    }

    return result;
  }, [descListData, ascListData, isDescending, pageNumber]);

  const onChangePage = (event: React.ChangeEvent<unknown>, page: number) => {
    setPageNumber(page);
    window.scrollTo(0, 0);
  };

  const onClickDelete = () => {};

  const onClickSortButton = () => {
    setIsDescending((prev) => !prev);
    setPageNumber(1);
  };

  return (
    <ContentsLayout>
      <Header title="사용 흐름 분석" isDatePicker={false}>
        <HeaderRightWrapper>
          {/* <SearchInputWrapper>
            <input placeholder="검색어를 입력하세요" />
            <IconSearch />
          </SearchInputWrapper>
          <IconDelete
            onClick={() => {
              onClickDelete();
            }}
          /> */}
          <PageViewSortWrapper onClick={onClickSortButton}>
            <PageViewSortTitle>
              {isDescending ? '페이지 뷰 높은 순' : '페이지 뷰 낮은 순'}
            </PageViewSortTitle>
            <PageViewSortIcon>
              <IconSMArrowDown $isDescending={isDescending} />
            </PageViewSortIcon>
          </PageViewSortWrapper>
        </HeaderRightWrapper>
      </Header>

      <ContainerGrid $spacing="xsm">
        {loading[GET_PAGE_LIST] ? (
          <SpinnerWrapper>
            <Spinner />
          </SpinnerWrapper>
        ) : (
          printPageList
        )}
      </ContainerGrid>
      <PaginationWrapeer>
        <PaginationCustom
          page={pageNumber}
          count={lastPageNumber}
          shape="rounded"
          onChange={onChangePage}
          defaultPage={1}
        />
      </PaginationWrapeer>
    </ContentsLayout>
  );
};

export default PageList;
